<template>
  <div class="w-full bg-white height-100">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Variables</h3></template
      >
      <div><Table /></div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create an Push Notification Template
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white py-10 px-20 menucontrol-scroll fixed-top">
      <div class="flex justify-around items-start gap-4">
        <div class="w-3/5 flex justify-start">
          <div class="flex items-center justify-end">
            <p class="col-4f text-xl cross mb-0 whitenowrap font-semibold">
              Preview
            </p>
          </div>
          <div class="w-3/5">
            <div class="relative text-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/marcom/campaignImage/Group 118.png"
                alt="sms"
                class="width-whatsapp mx-auto"
              />
              <div
                class="absolute top-18per left-0 mx-auto right-0 width-whatsapps flex justify-center items-start"
              >
                <div>
                  <div class="text-center">
                    <h4 class="text-white font-medium fsize50">
                      {{ timeFormat }}
                    </h4>

                    <small class="text-white fsize16">{{ dateFormat }}</small>
                  </div>

                  <div class="mt-6 wid-mobiless">
                    <div
                      class="flex justify-between items-center bg-cbe3ec py-2 px-4 rounded-tlr-20px"
                    >
                      <div class="flex items-center">
                        <img
                          :src="
                            brandProfile.primaryLogo
                              ? `${this.$imageURL}` + brandProfile.primaryLogo
                              : `data:image/png;base64,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`
                          "
                          alt="logo"
                          class="w-8 h-8"
                        />
                        <p class="font-medium pl-2 mb-0 text-8f8f8f">
                          <!-- {{ templateName ? templateName : "Brained" }} -->
                          {{
                            selectedProject.projectName
                              ? selectedProject.projectName
                              : "Bumper Offer"
                          }}
                        </p>
                      </div>
                      <small class="text-8f8f8f fsize10">7m ago</small>
                    </div>

                    <div class="bg-8ec1d4 rounded-blr-20px text-left p-4">
                      <h4 class="text-black fsize14 mb-0">
                        {{ templateTitle ? templateTitle : "Get excited!" }}
                      </h4>
                      <p class="mb-0 fsize12 text-black">
                        {{
                          bodyText
                            ? bodyText
                            : "Your order is confirmed and is on its way!"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-white w-2/5 h-530px cust-shadow rounded-10px px-8 pt-8 pb-16 relative"
        >
          <div v-if="!isshowform">
            <div>
              <h6 class="col-4f text-xl mb-0">Template Name</h6>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="templateName"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateName === "" ? "This Field is required" : "" }}
              </p>
            </div>
            <!-- <div class="mt-6">
              <h6 class="col-4f text-xl mb-0">Template Type</h6>

              <el-select
                v-model="value"
                placeholder="Select"
                multiple
                class="w-full mt-2"
              >
                <el-option
                  v-for="item in templateTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div> -->

            <div class="mt-6">
              <h6 class="col-4f text-lg mb-0">Message Title</h6>

              <el-input
                placeholder="Enter..."
                class="mt-2 w-full"
                v-model="templateTitle"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ templateTitle === "" ? "This Field is required" : "" }}
              </p>
            </div>

            <div class="mt-6">
              <div class="flex justify-between items-end mb-2">
                <h6 class="col-4f text-lg">Message Text</h6>
                <!-- <p
                  class="text-sm underline text-primary cursor-pointer"
                  @click="dialogVisible = true"
                >
                  Variable help
                </p> -->
              </div>
              <el-input
                placeholder="Enter..."
                class="mt-2 w-full textarea-h100px"
                v-model="bodyText"
                type="textarea"
              ></el-input>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ bodyText === "" ? "This Field is required" : "" }}
              </p>
            </div>
          </div>
          <!-- <div v-if="isshowform">
            <h6 class="col-4f text-xl mb-0">Image (Optional)</h6>

            <div class="bg-aeaeae rounded-12px mt-6 p-5 flex items-center">
              <feather-icon
                icon="UploadIcon"
                svgClasses="w- h-6"
                class="text-white"
              />
              <p class="text-white fsize12 mb-0 pl-2">
                Upload an image in png,jpeg or jpg format.
              </p>
            </div>

            <div class="mt-8 p-5 bg-fff7da rounded-10px">
              <p class="fsize12">
                Note:Following are the file formats and their respective sizes
                which are accepted for upload
              </p>

              <div class="mt-2">
                <p class="fsize12 mb-0 pb-1">
                  1. Image:JPEG and PNG (Max size 2MB)
                </p>
                <p class="fsize12 mb-0 pb-1">
                  1. Image:JPEG and PNG (Max size 2MB)
                </p>

                <p class="fsize12 mb-0 pb-1">1. Video:MP4 (Max size 20MB)</p>
                <p class="fsize12 mb-0">1. Document:PDF (Max size 2MB)</p>
              </div>
            </div>
          </div> -->
          <!-- <div class="flex gap-2 justify-center mt-12 bfix">
            <p
              @click="isshowform = false"
              :class="[
                isshowform
                  ? 'bg-gray text-primary '
                  : 'bg-primary text-primary',
              ]"
              class="w-3 h-3 block cursor-pointer rounded-full"
            ></p>
            <p
              @click="isshowform = true"
              :class="[
                isshowform
                  ? 'bg-primary text-primary '
                  : ' bg-gray text-primary ',
              ]"
              class="w-3 h-3 block bg-gray rounded-full cursor-pointer"
            ></p>
          </div> -->

          <!-- <div class="absolute bottom-0 margin-niche right-0">
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
                @click="handleClick()"
              />
            </div>
          </div> -->
          <div
            class="absolute bottom-0 margin-niche right-0 bg-primary w-24 h-24 rounded-full"
          >
            <div
              class="flex justify-center items-center w-24 h-24"
              @click="handleClick()"
            >
              <feather-icon
                icon="ArrowRightIcon"
                svgClasses="w-10 h-10"
                class="text-white flex"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import Table from "@/views/adminPanel/pages/variables/components/Table.vue";
export default {
  components: {
    Table,
  },
  data() {
    return {
      dialogVisible: false,
      textarea: "",
      messageTitle: "",
      templateTypeOptions: "",
      templateName: "",
      templateTitle: "",
      bodyText: "",
      isshowform: false,
      submitted: false,
    };
  },
  watch: {
    templateTitle() {
      this.whitespaceRemove();
    },
    bodyText() {
      this.whitespaceRemove();
    },
    templateName() {
      this.whitespaceRemove();
    },
  },
  methods: {
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.templateTitle = this.templateTitle
          ? this.templateTitle.trimStart()
          : "";
        this.bodyText = this.bodyText ? this.bodyText.trimStart() : "";
        this.templateName = this.templateName
          ? this.templateName.trimStart()
          : "";
      });
    },
    async handleClick() {
      // this.$router.push({ name: name });
      this.submitted = true;
      if (
        this.templateTitle !== "" &&
        this.bodyText !== "" &&
        this.templateName !== ""
      ) {
        let payload = {
          title: this.templateTitle,
          body: this.bodyText,
          templateName: this.templateName,
          projectId: this.selectedProject._id,
          projectName: this.selectedProject.projectName,
          displayName: this.selectedProject.displayName,
          user: this.taskListUsers.PM[0]._id,
        };

        let data = await this.$store.dispatch(
          "pushNotification/createPushNotificationTemplate",
          payload
        );
        if (data.code == 200) {
          this.$swal({
            text: "Created Successfully",
            icon: "success",

            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
          let data = "Push Notification";
          this.$store.commit("template/TEMPLATE_VALUE_STORE", data);
          this.$router.push({ name: "marcom-Templates" });
        }
      }
      console.log(data, "push");
    },
  },

  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("marcom", ["taskListUsers"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("template", ["valueTemplate"]),
    dateFormat() {
      return moment().format("ddd, MMMM DD");
    },
    timeFormat() {
      return moment().format("HH:mm a");
    },
  },
};
</script>
